// extracted by mini-css-extract-plugin
export default {"ValidationError":"formValidationError_ValidationError__KkSy2"};